export default "__VITE_ASSET__GFaAk_Un__"